import { useSelector } from "react-redux";
import { ApplicationState } from "src/store";

export const useLoadingStateState = () => {
  return useSelector((state: ApplicationState) => state.isLoading);
};
